import React, { useState } from "react";
import { Card, Switch, Button, Popconfirm, Table, Checkbox } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import "./DPCard.scss";

// const { Option } = Select;

const DPCard = ({ dp, onUpdate, onRemove }) => {
  const [localDP, setLocalDP] = useState(dp);

  const handleUpdate = (updates) => {
    const updatedDP = { ...localDP, ...updates };
    setLocalDP(updatedDP);
    onUpdate(updatedDP);
  };



  // Generate service data from API response
  const serviceData = localDP.services ? localDP.services.map((businessType, index) => ({
    key: businessType.slug || index,
    business: businessType.name || businessType.slug,
    services: businessType.services || []
  })) : [];

  // Get all unique service types from all business types
  const allServiceTypes = [...new Set(
    serviceData.flatMap(bt => bt.services.map(s => s.slug))
  )];

  // Helper function to check if a service is active for a business type
  const isServiceActive = (businessSlug, serviceSlug) => {
    const businessType = serviceData.find(bt => bt.key === businessSlug);
    return businessType?.services.some(s => s.slug === serviceSlug) || false;
  };

  // Create table columns dynamically based on active services
  const serviceColumns = [
    {
      title: "Business",
      dataIndex: "business",
      key: "business",
      width: 120,
      render: (text) => <span className="business-name">{text}</span>
    },
    ...allServiceTypes.map(serviceSlug => ({
      title: serviceSlug.toUpperCase(),
      dataIndex: serviceSlug,
      key: serviceSlug,
      width: 80,
      align: "center",
      render: (_, record) => (
        <Checkbox
          checked={isServiceActive(record.key, serviceSlug)}
          disabled={true} // Read-only display
          className="service-checkbox"
        />
      )
    }))
  ];


  return (
    <Card className="dp-card">
      <div className="dp-header">
        <div className="dp-info">
          <div className="dp-name-row">
            <span className="dp-label">Name</span>
            <span className="dp-value">: {localDP.name}</span>
          </div>
          <div className="dp-id-row">
            <span className="dp-label">ID</span>
            <span className="dp-value">: {localDP.dpId}</span>
          </div>
          <div className="dp-type-row">
            <span className="dp-label">Type</span>
            <span className="dp-value">: {localDP.type}</span>
          </div>
          <div className="dp-status-row">
            <span className="dp-label">Status</span>
            <span className="dp-value">: </span>
            <Switch
              checked={localDP.status}
              onChange={(checked) => handleUpdate({ status: checked })}
              size="small"
              className="dp-status-switch"
            />
          </div>
        </div>
        <div className="dp-actions">
          <Popconfirm
            title="Are you sure you want to remove this Delivery Partner?"
            onConfirm={onRemove}
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="text"
              icon={<DeleteOutlined />}
              className="remove-dp-btn"
              danger
            />
          </Popconfirm>
        </div>
      </div>

      <div className="hub-selection">
        <div className="hub-row">
          <div className="hub-item">
            <span className="hub-label">FM Hub</span>
            <div className="hub-display">
              {localDP.fmHub ? (
                <span className="hub-name">{localDP.fmHub}</span>
              ) : (
                <span className="no-hub">No FM Hub assigned</span>
              )}
              {localDP.fmHubId && (
                <span className="hub-id"> (ID: {localDP.fmHubId})</span>
              )}
            </div>
          </div>
          <div className="hub-item">
            <span className="hub-label">LM Hub</span>
            <div className="hub-display">
              {localDP.lmHub ? (
                <span className="hub-name">{localDP.lmHub}</span>
              ) : (
                <span className="no-hub">No LM Hub assigned</span>
              )}
              {localDP.lmHubId && (
                <span className="hub-id"> (ID: {localDP.lmHubId})</span>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="service-matrix">
        {serviceData.length > 0 && allServiceTypes.length > 0 ? (
          <Table
            columns={serviceColumns}
            dataSource={serviceData}
            pagination={false}
            size="small"
            className="service-table"
            bordered
          />
        ) : (
          <div className="no-services-table">
            <span>No services configured</span>
          </div>
        )}
      </div>
    </Card>
  );
};

export default DPCard;
